<template>
  <teleport to="body">
    <div class="modal" v-if="showModal">
      <div class="wrappers">
        <font-awesome-icon icon="times" class="exit" @click.stop.prevent="close" />
        <h3 class="modal-title">Add to Recipe</h3>
        <section v-if="chooseSearch" class="choose">
          <button @click.stop.prevent="adding('ingredients')">
            <font-awesome-icon icon="fa-carrot" />
            Add an Ingredient
          </button>
          <button @click.stop.prevent="adding('recipe')"><font-awesome-icon icon="fa-book" />Add a Sub Recipe</button>
        </section>
        <section v-if="searchRecipes" class="sub">
          <input type="search" placeholder="Search recipes to add..." v-model="subRecipesQuery" />
          <ul id="add">
            <div v-for="recipe in foundSubRecipes" :key="recipe" class="ingredient-btn">
              <p>{{ recipe.value.escaped }}</p>
              <p v-if="recipe.value.costing_type == 'servings'">One Serving</p>
              <div v-else>
                <label for="usage">Usage:</label>
                <input type="number" step="any" name="usage" v-model="recipe.usage" />
                <label for="ing-uom">UOM:</label>
                <input list="uoms" name="ing-uom" v-model="recipe.uom" />
                <datalist id="uoms">
                  <option v-for="unit in cogsUOM" v-bind:key="unit.key">{{ unit.key }}</option>
                </datalist>
              </div>
              <font-awesome-icon :icon="['fas', 'plus']" @click="add(recipe, 'sub')" />
            </div>
          </ul>
        </section>
        <section v-if="searchIngredients" class="ing">
          <input type="search" placeholder="Search ingredients to add..." v-model="ingredientsQuery" />
          <ul id="add">
            <div v-for="ingredient in foundIngredients" :key="ingredient" class="ingredient-btn">
              <p>{{ ingredient.key }}</p>
              <div>
                <label for="usage">Usage</label>
                <input type="number" step="any" name="usage" v-model="ingredient.usage" />
                <label for="ing-uom">UOM</label>
                <input list="uoms" name="ing-uom" v-model="ingredient.uom" />
                <datalist id="uoms">
                  <option v-for="unit in cogsUOM" v-bind:key="unit.key">{{ unit.key }}</option>
                </datalist>
              </div>
              <font-awesome-icon :icon="['fas', 'plus']" @click="add(ingredient, 'ing')" />
            </div>
          </ul>
        </section>
      </div>
    </div>
  </teleport>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AddToRecipe",
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    ingredients: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["close", "confirm"],

  data() {
    return {
      chooseSearch: true,
      searchRecipes: false,
      searchIngredients: false,
      searchQuery: "",
      ingredientsQuery: "",
      recipesQuery: "",
      subRecipesQuery: "",
      foundIngredients: [],
      foundRecipes: [],
      foundSubRecipes: [],
      recipeUsage: 0,
      recipeUOM: "",
      ingredientUsage: 0,
      ingredientUOM: "",
    };
  },

  computed: {
    ...mapGetters({
      cogsSearchProducts: "cogsSearchProducts",
      cogsSearchRecipes: "cogsSearchRecipes",
      cogsUOM: "cogsUOM",
    }),
  },
  methods: {
    adding(type) {
      this.chooseSearch = false;
      if (type === "ingredients") {
        this.searchIngredients = true;
        this.searchRecipes = false;
      } else if (type === "recipe") {
        this.searchRecipes = true;
        this.searchIngredients = false;
      }
    },

    add(item, type) {
      if (type === "ing") {
        this.$emit("confirm", {
          type: "ingredient",
          item: item,
        });
      } else if (type === "sub") {
        this.$emit("confirm", {
          type: "sub-recipe",
          item: item,
        });
      }
      this.clearAll();
    },

    clearAll() {
      this.searchQuery = "";
      this.ingredientsQuery = "";
      this.recipesQuery = "";
      this.subRecipesQuery = "";
      this.foundIngredients = [];
      this.foundRecipes = [];
      this.foundSubRecipes = [];
      this.recipeUsage = 0;
      this.recipeUOM = "";
      this.ingredientUsage = 0;
      this.ingredientUOM = "";
      this.chooseSearch = true;
      this.searchRecipes = false;
      this.searchIngredients = false;
    },

    close() {
      this.clearAll();
      this.$emit("close");
    },

    queryCheck(query, list) {
      if (query.length > 1) {
        return list(query);
      } else {
        return [];
      }
    },
  },
  watch: {
    searchQuery: function () {
      this.foundProducts = this.queryCheck(this.searchQuery, this.cogsSearchProducts);
    },

    ingredientsQuery: function () {
      this.foundIngredients = this.queryCheck(this.ingredientsQuery, this.cogsSearchProducts);
    },

    recipesQuery: function () {
      this.foundRecipes = this.queryCheck(this.recipesQuery, this.cogsSearchRecipes);
    },

    subRecipesQuery: function () {
      this.foundSubRecipes = this.queryCheck(this.subRecipesQuery, this.cogsSearchRecipes);
    },
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 1rem;
}

.wrappers {
  background-color: var(--primary-colour);
  border-radius: 1rem;
  box-shadow: var(--box-shadow);
  padding: 2rem;
  max-width: 90vw;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  min-width: 500px;

  .exit {
    top: 1rem;
    cursor: pointer;
  }

  .modal-title {
    margin: 0 0 2rem 0;
    color: var(--text-colour);
    text-align: center;
  }

  .choose {
    display: flex;
    gap: 1rem;
    justify-content: center;
    margin-bottom: 2rem;

    button {
      display: flex !important;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 1rem 2rem;
      gap: 0.5rem;
      background-color: var(--action-colour);
      color: var(--secondary-text-colour);
      border: none;
      border-radius: 0.5rem;
      cursor: pointer;
      font-weight: 500;
      transition: all 0.2s ease;

      &:hover {
        background-color: color-mix(in srgb, var(--action-colour) 90%, black 10%);
        transform: translateY(-2px);
      }
    }
  }

  .sub,
  .ing {
    input[type="search"] {
      width: 100%;
      padding: 0.75rem;
      margin-bottom: 1rem;
      border: none;
      border-radius: 0.5rem;
      box-shadow: var(--box-shadow);
      font-size: 1rem;

      &::placeholder {
        color: var(--secondary-text-colour);
      }
    }

    #add {
      max-height: 40vh;
      overflow-y: auto;
      margin: 0;
      padding: 0;
      list-style: none;

      .ingredient-btn {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1rem;
        margin-bottom: 0.5rem;
        border-bottom: 1px solid var(--primary-colour);
        p {
          color: var(--text-colour);
          margin: 0;
        }

        svg {
          color: var(--action-colour);
          cursor: pointer;
          padding: 0.5rem;
          border-radius: 50%;
          transition: all 0.2s ease;
        }

        div {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          margin-left: 1rem;

          label {
            font-size: 0.9rem;
            color: var(--action-colour);
            margin: 0;
          }

          input {
            width: 50px;
            padding: 0.25rem;
            border: none;
            border-radius: 0.25rem;
            box-shadow: var(--box-shadow);
          }
        }
      }
    }
  }

  .modal-footer {
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
    margin-top: 2rem;
    padding-top: 1rem;
    border-top: 1px solid var(--tertiary-colour);

    button {
      padding: 0.75rem 1.5rem;
      border-radius: 0.5rem;
      border: none;
      cursor: pointer;
      font-weight: 500;
      transition: all 0.2s ease;

      &.btn-primary {
        background-color: var(--action-colour);
        color: white;

        &:hover {
          background-color: color-mix(in srgb, var(--action-colour) 90%, black 10%);
        }
      }

      &.btn-secondary {
        background-color: var(--tertiary-colour);
        color: var(--text-colour);
        border: 1px solid var(--secondary-colour);

        &:hover {
          background-color: var(--secondary-colour);
        }
      }
    }
  }
}

@media only screen and (orientation: portrait) {
  .modal {
    padding: 0.5rem;
    align-items: flex-start;
    padding-top: 2rem;
  }

  .wrappers {
    min-width: unset;
    width: 100%;
    max-width: 100%;
    padding: 1rem;

    .choose {
      flex-direction: column;

      button {
        width: 100%;
      }
    }

    .modal-footer {
      flex-direction: column;

      button {
        width: 100%;
        justify-content: center;
      }
    }

    .sub,
    .ing {
      #add .ingredient-btn {
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;

        div {
          margin-left: 0;
          width: 100%;
        }

        &.extended div {
          flex-direction: row;
          justify-content: space-between;
        }
      }
    }
  }
}
</style>
